import config from '../../config/config';

import getRequest from './base/get';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

export default {
  /**
   * Run campaign
   */
  runCampaign: (data: any): Promise<any> => {
    const parameters = { ...data };
    return postRequest(
      `${config.accountApiUrl}api/super-admin/v1/campaign/reset-password`,
      parameters,
    );
  },

  /**
   * Fetch the Accounts list
   */
  fetchAccounts: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/campaign/get-accounts`, {
      ...parameters,
    });
  },

  /**
   * Fetch the templates list
   */
  fetchTemplates: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/campaign/templates`, {
      ...parameters,
    });
  },

  /**
   * Fetch the campaigns
   */
  fetchCampaigns: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/campaign/reset-password`, {
      ...parameters,
    });
  },

  /**
   * Fetch the single campaign
   */
  fetchSingleCampaign: (id: string): Promise<any> => {
    return getRequest(`${config.accountApiUrl}api/super-admin/v1/campaign/reset-password/${id}`);
  },
};
